module.exports = __webpack_public_path__ + "static/img/287_TO8_2443.f5a2c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/287_TO8_2443.jpg
// module id = 2rsn
// module chunks = 0